import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import _get from 'lodash/get';
import SourceType from 'types/Source';

// Interfaces
import DirectoryProps from 'types/Directory';

// Helpers
import createAttributes from './_helpers/createAttributes';
import useEntityTypes, { PERSON_ENTITY_TYPE_KEY } from 'helpers/useEntityTypes';

// Actions
import { toggleCreateAttributeDialog } from 'store/attribute';

// Components
import withSource from 'components/withSource';
import AttributeMenu from './AttributeMenu';
import useAllSourceMappings from 'components/Mappings/_helpers/useAllSourceMappings';

interface Props {
  onSelectAttribute: (attribute: any) => void;
  onClose: () => void;
  selectedDestinations: string[];
  sourceId: string;
  source: SourceType;
  directory: DirectoryProps;
}

// Container
const AttributeMenuContainer = (props: Props) => {
  const { sourceId, directory, selectedDestinations, source, ...otherProps } = props;

  const entityTypes = useEntityTypes();
  const userConfig = _get(entityTypes, PERSON_ENTITY_TYPE_KEY);
  const { isPrimary } = source;

  const dispatch = useDispatch();
  const handleToggleCreateAttributeDialog = () => {
    dispatch(toggleCreateAttributeDialog());
  };

  const remainingSourceMappings = useAllSourceMappings({ directory, sourceId })[0] || [];
  const initialAttributes = useMemo(
    () => createAttributes(userConfig, remainingSourceMappings, selectedDestinations),
    [userConfig, remainingSourceMappings, selectedDestinations],
  );

  // Validation

  return (
    <AttributeMenu
      {...otherProps}
      isPrimary={isPrimary}
      attributes={initialAttributes}
      toggleCreateAttributeDialog={handleToggleCreateAttributeDialog}
    />
  );
};

export default withSource(AttributeMenuContainer);
